<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>

<style>


</style>


 


// WEBPACK FOOTER //
// src/components/Channels.vue